<template>
  <div class="box-wrapper">
    <RequestPasswordForm v-if="step === 'request'" />
    <Instructions v-if="step === 'instructions'" />
    <ResetPasswordForm v-if="step === 'reset'" />
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  components: {
    RequestPasswordForm: () => import('~/components/ResetPassword/RequestPasswordForm.vue'),
    ResetPasswordForm: () => import('~/components/ResetPassword/ResetPasswordForm.vue'),
    Instructions: () => import('~/components/ResetPassword/Instructions.vue'),
  },
  data: () => ({
    step: 'request',
  }),
  provide() {
    const data = {};
    Object.defineProperty(data, 'token', {
      enumerable: true,
      get: () => this.token,
    });
    return data;
  },
  computed: {
    token() {
      return this.$route.query.reset_password_token;
    },
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'auth/requestResetPasswordSuccess') {
        this.step = 'instructions';
      }
    });

    if (this.token !== undefined) {
      this.step = 'reset';
    }
  },
};
</script>

<style lang="scss" scoped>
.box-wrapper {
  margin: auto 0;
  padding: 60px 0;
}
</style>
